import { type ReactNode, type Ref } from 'react';
import * as React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ANIMATIONS } from '../../utils';

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding: 100px 0;
`;

interface ToutWrapperProps {
  children: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}

export const ToutWrapper: React.ComponentType<ToutWrapperProps> = React.memo(
  React.forwardRef<HTMLDivElement, ToutWrapperProps>(
    ({ children, className }, ref) => {
      return (
        <Wrapper ref={ref} className={className} {...ANIMATIONS.SimpleFadeIn}>
          {children}
        </Wrapper>
      );
    }
  )
);
